export function resolveTitleTemplate(titleDefinition, valueSource = {}) {
  const configuredTitle =
    titleDefinition && typeof titleDefinition === "object"
      ? titleDefinition.title
      : titleDefinition;

  if (
    configuredTitle === undefined ||
    configuredTitle === null ||
    configuredTitle === ""
  ) {
    return "";
  }

  return String(configuredTitle).replace(
    /{([^{}]*)}/g,
    (placeholder, componentName) => {
      const key = componentName?.trim();

      if (!key) {
        return "";
      }

      const resolvedValue = valueSource?.[key];

      return resolvedValue !== undefined &&
        resolvedValue !== null &&
        resolvedValue !== ""
        ? String(resolvedValue)
        : "";
    }
  );
}

